import { FileArrowDownIcon } from '@phosphor-icons/react';

import { Button } from '@/components/ui/button';

interface OrdersHistoryEventActionsProps {
  onGenerateReport: () => void;
  isGeneratingReport: boolean;
}

export function OrdersHistoryEventActions({
  onGenerateReport,
  isGeneratingReport,
}: OrdersHistoryEventActionsProps) {
  return (
    <Button
      key="generate-report"
      data-testid="generate-report-button"
      variant="outline"
      size="sm"
      onClick={onGenerateReport}
      startIcon={<FileArrowDownIcon />}
      isLoading={isGeneratingReport}
    >
      Generate Report
    </Button>
  );
}
